// IE 2026 10 26 / ODOO-348733 (заказ webscm #105553: netOn и реактивные чтения в редьюсерах на каждый проход): редьюсеры sigma классического
// графа (AttrGraph, ветка opt-in 'command-hoveredNode' — граф DataHub) на полном проходе (каждый refresh: вход / уход наведения, выделение,
// чипсы) звались на каждый узел и ребро и каждый раз читали реактивное состояние компонента: this.state.* (наведение, соседи, отбор — Set),
// this.CHIPS, this.params, netOn() (this.WIDGET.record.doc.params.graph_network) — ~20 ловушек Proxy на узел / ребро, ~40–84 мс на проход
// при 7 181 / 16 520 (разбор scratchpad neton/analysis.txt). Здесь: снимок этих чтений — ОДИН на проход (snapCache: сброс в обёртке
// sigma.refresh перед каждым проходом и микрозадачей), редьюсеры по снимку — та же логика, что у прежних (AttrGraph.vue nodeReduceOld /
// edgeReduceOld, netNodeReduce / netEdgeReduce), без второй копии атрибутов: sigma 3.0.3 addNode / addEdge уже копирует их
// (Object.assign({}, graph.getXAttributes(key))) перед редьюсером. Выключатель fe.perf.graphReducerSnap = false — прежние редьюсеры.
import { toRaw } from 'vue'

export const GRAPH_REDUCER_SNAP_FLAG = 'fe.perf.graphReducerSnap'
const OFF = Object.freeze({ on: false })

// кэш снимка: read() — один раз до сброса; сброс — reset() (перед каждым проходом sigma) и микрозадачей после первого чтения
// (частичные обновления узла из событий графа идут вне refresh — снимок не переживает текущую задачу)
export function snapCache(read, defer = queueMicrotask) {
    let snap = null
    return {
        get() {
            if (!snap) { snap = read(); defer(() => { snap = null }) }
            return snap
        },
        reset() { snap = null },
    }
}

// все реактивные чтения редьюсеров — один раз; vm — компонент AttrGraph (публичный прокси). Наборы state — сырые (set-ловушка Vue
// кладёт toRaw(value)); .has по строковым ключам узлов / рёбер даёт тот же ответ, что у реактивного Set
export function reducerSnapRead(vm) {
    if (vm.store?.setting?.(GRAPH_REDUCER_SNAP_FLAG, true) === false) return OFF
    const st = toRaw(vm.state) || {}, cs = vm.params?.['command-select'] || {}
    const h = st.hoveredNode, hN = st.hoveredNeighbors, sN = st.selector_valuesNeighbors, fv = st.filter_values
    const iE = st.selector_values_inEdges, oE = st.selector_values_outEdges
    const s = {
        on: true, net: !!vm.netOn(), g: vm.graph, h, hN, sN, fv, iE, oE,
        // nodeReduceOld: hoveredNeighbors?.size || hoveredNode || selector_valuesNeighbors?.size || filter_values?.size || CHIPS.length
        dim: !!(hN?.size || h || sN?.size || fv?.size || (vm.CHIPS || []).length),
        // edgeReduceOld: selector_values_inEdges?.size || selector_values_outEdges?.size || hoveredNode; selMode — без наведения
        edgeAny: !!(iE?.size || oE?.size || h), selMode: !!(iE?.size || oE?.size),
        nodeHideLabel: !!cs.node?.hideLabel, edgeHidden: !!cs.edge?.hidden, edgeHideLabel: !!cs.edge?.hideLabel,
        labelCut: vm._labelCut, labelVis: vm._labelVis,
        netSel: null,   // выделенные узлы и соседи (netSelSets) — лениво, один раз на проход
        netSelSets: () => vm.netSelSets(),
    }
    return s
}

const netSel = (s) => s.netSel || (s.netSel = s.netSelSets())

// = AttrGraph.netNodeReduce по снимку
export function netNodeReduceSnap(node, res, s) {
    if (s.h) { if (res.label === '') res.label = null; return }
    const ns = netSel(s)
    if (!ns.sel.size || ns.sel.has(node) || ns.nb.has(node)) return
    res.label = null; res.type = ''; res.color = '#f6f6f6'; res.zIndex = 0
}

// = AttrGraph.netEdgeReduce по снимку
export function netEdgeReduceSnap(edge, attributes, res, s) {
    if (attributes.selector) return
    const h = s.h, g = s.g
    if (h) {
        if (s.edgeHidden && g.source(edge) !== h && g.target(edge) !== h) res.hidden = true
        return
    }
    const sel = netSel(s).sel
    if (!sel.size) return
    if (sel.has(g.target(edge))) { res.hidden = false; res.color = '#7798FA'; res.zIndex = 5 }
    else if (sel.has(g.source(edge))) { res.hidden = false; res.color = '#6DDB55'; res.zIndex = 5 }
}

// = nodeReduceOld (AttrGraph.vue, ветка opt-in) по снимку; attributes — уже копия sigma, правится на месте
export function nodeReduceSnap(node, attributes, s) {
    const res = attributes
    { const cutL0 = s.labelCut?.get(node); if (cutL0 && res.label && s.h !== node) res.label = cutL0 }
    if (attributes.own) { res.forceLabel = true; res.zIndex = Math.max(res.zIndex || 0, 6) }
    if (res.selector) {
        res.color = 'rgb(255, 150, 30)'
        res.size = (res.size || 5) * 1.4
        res.forceLabel = true
        res.zIndex = 10
    } else if (attributes.dim_hl) {
        res.color = 'rgb(255, 150, 30)'
        res.size = (res.size || 5) * 1.25
        res.forceLabel = true
        res.zIndex = 9
    }
    if (res.highlighted) {
        //
    } else if (s.dim) {
        if (!s.hN?.has(node) && s.h !== node && !s.sN?.has(node) && !s.fv?.has(node)) {
            res.label = ''
            res.type = ''
            res.color = '#f6f6f6'
        }
    } else if (s.nodeHideLabel) {
        res.label = ''
    } else if (res.label && s.labelVis) {
        if (s.labelVis.has(node)) res.forceLabel = true
        else res.label = ''
    }
    if (s.net) netNodeReduceSnap(node, res, s)
    return res
}

// = edgeReduceOld по снимку; исходные color / zIndex запомнены до правки (прежний код брал их из нетронутой копии attributes)
export function edgeReduceSnap(edge, attributes, s, graph) {
    const res = attributes, color0 = attributes.color, zIndex0 = attributes.zIndex
    if (s.edgeAny) {
        if (s.selMode) res.hidden = true
        else { res.color = '#e6e9ee'; res.zIndex = 0 }
        if (s.iE?.has(edge) && s.oE?.has(edge)) {
            res.hidden = false; res.color = color0; res.zIndex = zIndex0
        } else if (s.iE?.has(edge) || graph.target(edge) === s.h) {
            res.hidden = false
            res.color = '#7798FA'; res.zIndex = 5
        } else if (s.oE?.has(edge) || graph.source(edge) === s.h) {
            res.hidden = false
            res.color = '#6DDB55'; res.zIndex = 5
        }
    } else if (s.edgeHidden) {
        res.hidden = true
    }
    if (s.edgeHideLabel) res.label = ''
    if (attributes.selector) {
        res.hidden = false
        res.color = 'rgb(255, 150, 30)'
        res.size = Math.max(res.size || 1, 5)
        res.zIndex = 10
    }
    if (s.net) netEdgeReduceSnap(edge, attributes, res, s)
    return res
}
